import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { loadTaxSearchResults } from '@redux/modules/listing';

import Card from '@components/smartAdminUI/Card';
import Modal from '@components/smartAdminUI/Modal';
import TaxAutoPopForm from '@components/form/forms/TaxAutoPopForm';
import TaxAutoPopTable from '@components/table/TaxAutoPopTable';

const TaxAutoPopModal = props => {
  const {
    onListingClicked, id, clearForm, setClearForm,
  } = props;
  const dispatch = useDispatch();
  const autoPopListings = useSelector(state => state.listing.autoPopListings);

  const [listingData, setListingData] = useState('');

  // used for updating TAP table data and reset
  useEffect(() => {
    if (autoPopListings) {
      setListingData(autoPopListings);
    }
  }, [autoPopListings]);

  // POST request handling on selected listing by UniqueID
  const listingSelected = uniqueID => {
    const jsonBody = {
      action: 'select',
      where: {
        clause: [
          { Name: 'UniqueID', Value: uniqueID },
        ],
      },
    };
    onListingClicked(jsonBody);
    setListingData(''); // clear table data to destroy

    // resets TAP form after listing data is populated in form
    setClearForm(true);
  };

  const searchSubmit = taxData => {
    dispatch(loadTaxSearchResults(taxData));
  };

  return (
    <Modal
      id={id}
      modalHeader="Tax Auto Pop"
      position="center"
      size="lg"
    >
      <p className="text-center alert alert-info mt-2 mb-0 wobble-hor-bottom">
        <i className="far fa-exclamation-circle mr-2" />
        <strong>NOTE:</strong>
        &nbsp;
        Although new tax assessments are sent out to home owners at the beginning of each calendar year, Pillar 9&trade; does not typically receive
        new Calgary Tax Data until sometime in May, with all other municipalities following sometime thereafter. Please check back
        <strong>
          <a href="https://pillarnine.com/taxdata" target="_blank" rel="noreferrer">
            &nbsp;HERE
          </a>
        </strong>
        {' '}
        regularly, to see what data has been received for the current and past years.
      </p>
      <br />
      {
        listingData
        && (
          <Card>
            <TaxAutoPopTable
              displayData={listingData}
              onListingSelected={listingSelected}
              isModal
            />
          </Card>
        )
      }
      <Card>
        <TaxAutoPopForm
          onSearchSubmit={searchSubmit}
          formClear={clearForm}
        />
      </Card>
    </Modal>
  );
};

TaxAutoPopModal.propTypes = {
  clearForm: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onListingClicked: PropTypes.func.isRequired,
  setClearForm: PropTypes.func.isRequired,
};

export default TaxAutoPopModal;
